<template>
  <div>
    <div v-if="!loadStatus">
      <Skeleton width="100%" height="3.5rem" v-for="i in 15" :key="i" />
    </div>
    <!-- Recipient List Here -->
    <div v-else-if="recipientList.length">
      <RecipientList :recipients="recipientList" />
    </div>

    <!-- Empty State Here -->
    <div v-else>
      <EmptyState />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { progressStatus } from '../../helpers'

export default {
  components: {
    EmptyState: () => import('./EmptyState.vue'),
    RecipientList: () => import('./RecipientList.vue'),
    Skeleton: () => import('@/components/Universal/Skeleton')
  },

  computed: {
    ...mapState({
      loading: state => state.recipient.loadRecipientList,
      recipientList: state => state.recipient.recipientListRecords
    }),

    loadStatus() {
      return progressStatus(this.loading)
    }
  },

  mounted() {
    this.$store.dispatch('recipient/loadRecipientList')
  }
}
</script>

<style scoped lang="scss">
@import '@/global.scss';
</style>
